import toast from 'react-hot-toast';

import { usePostApiV5FirmsRequestsIdRecall } from '@liscio/api';
import { Dialog, Typography } from '@liscio/ui';

export type RecallRequestDialogProps = {
  open: boolean;
  requestId: string;
  onClose: () => void;
  onSuccessfulRecall?: () => void;
  onErroredRecall?: (error: unknown) => void;
};

/**
 * This component is used to recall a request.
 */
export const RecallRequestDialog = ({
  open,
  requestId,
  onClose,
  onSuccessfulRecall,
  onErroredRecall,
}: RecallRequestDialogProps) => {
  const { mutateAsync: recallRequestMutation, isLoading } =
    usePostApiV5FirmsRequestsIdRecall({
      mutation: {
        onSuccess: () => {
          if (onSuccessfulRecall) {
            onSuccessfulRecall();
          }
        },
        onError: (error) => {
          if (onErroredRecall) {
            onErroredRecall(error);
          }
          toast.error('Error recalling request');
          console.error('Error recalling request:', error);
        },
        onSettled: () => {
          onClose();
        },
      },
    });

  const handleRecall = () => {
    recallRequestMutation({
      id: requestId || '',
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Recall this request?"
      iconClose
      onSubmit={handleRecall}
      submitLabel="Yes, recall"
      submitBtnProps={{ color: 'error', disabled: isLoading }}
      cancelLabel="No, cancel"
      onCancel={onClose}
      cancelBtnProps={{ color: 'primary', disabled: isLoading }}
    >
      <Typography>
        Are you sure you want to recall this request for this recipient?
      </Typography>
      <Typography>Once recalled, the request cannot be resent.</Typography>
    </Dialog>
  );
};
